module.exports = __webpack_public_path__ + "img/unstabilized_asphalted_and_unstabilized.c640a6ff.png";